// extracted by mini-css-extract-plugin
export default {"container":"form_container__hp+qI","info":"form_info__NxHi2","link":"form_link__gnTqL"};